import { setupSmoothScroll,setupAccordions }  from '../common/js/_include';
// slickでswipe中にmodaalが表示されるのを回避するための判定用変数
let swiping = false;


// ------------------------------
// scroll smooth
// ------------------------------
$(() => {
  $('a[href^="#"]:not([class*="js-"])').each((i,e) => {
      setupSmoothScroll($(e),{buffer:100});
  });
});



// ------------------------------
// modaal
// ------------------------------
$(() => {
  $('[class*="js-modal-"]').each((i, e) => {
    const $e = $(e);
    // modaalデフォルトオプション
    const modalOptions = {
      animation_speed: 100,
      should_open: function(){
        // slickでswipe中はmodalを表示させない
        if(swiping){
          return false;
        }
        return true
      },
    }
    if ($e.hasClass('js-modal-youtube')) {
      if (!$e.attr('href')) {
        $e.attr('href', `https://www.youtube-nocookie.com/embed/${$e.attr('data-youtube')}?autoplay=1&mute=1&rel=0`)
      }
      modalOptions.type = 'video'
    }
    if ($e.hasClass('js-modal-img')) {
      modalOptions.type = 'image'
    }
    if ($e.hasClass('js-modal-inline')) {
      modalOptions.type = 'inline';
    }
    if ($e.hasClass('js-modal-start')) {
      modalOptions.start_open = true
    }
    $e.modaal(modalOptions)

    // クリック処理
    $e.on('click',function(){
      $e.modaal('open');
    })
  })
})

// ------------------------------
// select2
// ------------------------------
$(() => {
  $('.js-select').select2({
    width:'100%',
    minimumResultsForSearch: -1
  });
})

// ------------------------------
// slick
// ------------------------------
$(() => {
  const $slide = $('.js-product-slide')
  if ($slide.length <= 0) {
    return false;
  }
  for (const slide of $slide) {
      $(slide).slick({
        arrows:false,
        dots: true,
        autoplay:false,
        speed: 200,
      });

      // slick-dotsの要素移動
      $(slide).after($(slide).find('.slick-dots'));

  // クローンのdata-group属性外す
        $(slide).find('.slick-cloned a').removeAttr('data-group');

        // swipe中にmodaal.jsが実行されるのを回避
        // スライド切り替え前にフォーカスを解除
        $(slide).on(
          {
            'swipe': function (event, slick, direction) {
              swiping = true;
            },
            'afterChange': function (event, slick, currentSlide) {
              swiping = false;
            },
            'beforeChange':function(event, slick, currentSlide, nextSlide) {
              if (document.activeElement) {
                document.activeElement.blur();
              }
            }
          }
        );  }
    });


// ------------------------------
// アコーディオンの設定
// ------------------------------
$(()=>{
  const accordions = $('.js-details');
  setupAccordions(accordions);

});


// ボタンクリックでクラスを切り替える
const summary = document.querySelector('.title');

summary.addEventListener('click', () => {
 summary.classList.toggle('is-active');
});


document.addEventListener('DOMContentLoaded', function() {
  const newsItems = document.querySelectorAll('.news-container__item');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');  // スクロールで表示されたらクラスを追加
        observer.unobserve(entry.target); // 1回だけアニメーション
      }
    });
  }, { threshold: 0.4 });  // 要素の50%が画面に見えたときに発動

  newsItems.forEach(item => {
    observer.observe(item);
  });
});
